"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleOrderEmails = void 0;
const helpers_1 = require("../../helpers");
const getOrderById_1 = require("./getOrderById");
const __1 = require("..");
const region_1 = require("../../factories/region");
const timestampUtilities_1 = require("../timestampUtilities");
const factories_1 = require("../../factories");
const scheduleOrderEmails = async (supabase, order_id) => {
    // Define each email to be scheduled
    await factories_1.EmailLogRequestFactory.deleteScheduledEmailGroupByRef(supabase, `feedback_reminder_requests_${order_id}`);
    const order = await (0, getOrderById_1.getOrderById)(supabase, order_id);
    const emails = [];
    const variant = order.variants?.find((variant) => {
        return variant.id === order.default_variant_id;
    });
    if (!variant) {
        console.error(`No variant found for order ${order_id}`);
        return;
    }
    const first_region_id = variant?.order_lines?.reduce((acc, item) => {
        return acc !== undefined ? acc : item?.region_id;
    }, undefined);
    const timezone_offset = await (0, region_1.getRegionTimezoneISO)(supabase, first_region_id);
    const first_date = (0, __1.getVariantFirstDate)(variant);
    const last_date = (0, __1.getVariantLastDate)(variant);
    // Get current timestamp for comparison
    const now = new Date();
    // timezone_offset is in ISO format e.g., '+05:30', '-08:00'
    // i need to get 6pm one day before the first date in the region's timezone in  timestamptz,  e.g. 2025-06-23T17:21:00+07:00
    const first_date_timestamp = (0, timestampUtilities_1.createScheduledTimestamp)(first_date, -1, "18:00", timezone_offset, 0); // Day before
    const order_lines = variant?.order_lines || [];
    const golf_lines = order_lines.filter((line) => {
        return line.type === "GOLF";
    });
    // Example: Holiday Reminder Email
    const holiday_reminder_email = {
        language_code: "en",
        template_id: helpers_1.EMAIL_HOLIDAY_REMINDER,
        order_id: order_id,
        scheduled_delivery_date: first_date_timestamp,
        scheduled_ref: `feedback_reminder_requests_${order_id}`,
    };
    // Only add if scheduled time is in the future
    if (new Date(first_date_timestamp) > now) {
        emails.push(holiday_reminder_email);
    }
    else {
        console.log(`Skipping holiday reminder email for order ${order_id} - scheduled time is in the past`);
    }
    for (const line of golf_lines) {
        const latest_version = line.versions?.find((version) => {
            return version.id === line.latest_version_id;
        });
        if (!latest_version) {
            console.error(`No latest version found for line ${line.id} in order ${order_id}`);
            continue;
        }
        const config = latest_version.config;
        const date = config.where_when_who.date;
        const time = config.tee_time.groups[config.tee_time.groups.length - 1].start_time;
        const golf_email_delivery_date = (0, timestampUtilities_1.createScheduledTimestamp)(date, 0, time, timezone_offset, 300); // Day before
        // Example: Holiday Reminder Email for each golf line
        const golf_review_email_line = {
            language_code: "en",
            template_id: helpers_1.EMAIL_GOLF_REVIEW_REQUEST,
            order_id: order_id,
            order_line_id: line.id,
            scheduled_delivery_date: golf_email_delivery_date,
            scheduled_ref: `feedback_reminder_requests_${order_id}`,
        };
        // Only add if scheduled time is in the future
        if (new Date(golf_email_delivery_date) > now) {
            emails.push(golf_review_email_line);
        }
        else {
            console.log(`Skipping golf review email for line ${line.id} in order ${order_id} - scheduled time is in the past`);
        }
    }
    const last_date_timestamp = (0, timestampUtilities_1.createScheduledTimestamp)(last_date, 2, "11:00", timezone_offset, 0); // Day before
    // Example: Feedback Request Email - This is the email to review on trustpilot
    const feedback_request_email = {
        language_code: "en",
        template_id: helpers_1.EMAIL_FEEDBACK_REQUEST,
        order_id: order_id,
        scheduled_delivery_date: last_date_timestamp,
        scheduled_ref: `feedback_reminder_requests_${order_id}`,
    };
    // Only add if scheduled time is in the future
    if (new Date(last_date_timestamp) > now) {
        emails.push(feedback_request_email);
    }
    else {
        console.log(`Skipping feedback request email for order ${order_id} - scheduled time is in the past`);
    }
    for (const email of emails) {
        await (0, __1.sendEmail)(email);
    }
};
exports.scheduleOrderEmails = scheduleOrderEmails;
